module.exports = __webpack_public_path__ + "static/media/wh.74829420.jpg";